pds-modal-content {
  display: block;
  flex: 1 1 auto;
  width: 100%;

  &:has(.pds-modal-content.pds-modal-content--border-none) {
    border: 0;
  }

  &:has(.pds-modal-content.pds-modal-content--border-both) {
    border-block-end: 1px solid var(--pine-color-border-subtle);
    border-block-start: 1px solid var(--pine-color-border-subtle);
  }

  &:has(.pds-modal-content.pds-modal-content--border-top) {
    border-block-start: 1px solid var(--pine-color-border-subtle);
  }

  &:has(.pds-modal-content.pds-modal-content--border-bottom) {
    border-block-end: 1px solid var(--pine-color-border-subtle);
  }
}

.pds-modal-content {
  display: block;
  flex: 1 1 auto;
  // Max height is set via inline styles based on header and footer heights
  min-height: 0;
  width: 100%;

}
